import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227332aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "border-bottom pb-3" }
const _hoisted_3 = { class: "fw-bold mb-4 pb-4 border-bottom" }
const _hoisted_4 = { class: "d-flex flex-wrap m-20" }
const _hoisted_5 = { class: "w-100 d-flex justify-content-center mt-3" }
const _hoisted_6 = { class: "detail-table" }
const _hoisted_7 = { class: "d-flex justify-content-center mt-3" }

import Breadcrumb from '@/components/breadcrumb/index.vue'
import {
  ARTICLE_AUTO_POST_FIELD_NAME,
  ARTICLE_CONTENT_FIELD_NAME,
  ARTICLE_PUBLISH_STATUS_FIELD_NAME,
  ARTICLE_PUBLISHED_PUBLIC_VALUE,
  ARTICLE_TAGS_FIELD_NAME,
  ARTICLE_TITLE_FIELD_NAME,
  ArticleCreateMode,
  AUTO_POST_ENABLE,
  breadcrumb,
  CREATE_COMPLETE_MODAL_ID,
  URL_ARTICLE_LIST_PATH,
} from '@/views/community-admin/community-site/constants'
import { useRoute, useRouter } from 'vue-router'
import { computed, ComputedRef, ref, toRaw } from 'vue'
import { useStore } from 'vuex'
import { COMMUNITY_SITE_ADMIN_STORE } from '@/store/constants'
import { translate } from '@/languages/i18n'
import { isEmpty, pick } from 'lodash'
import Button from '@/components/button/index.vue'
import CompleteModal from '@/views/community-admin/community-site/components/modals/CompleteModal.vue'
import { Modal } from 'bootstrap'
import { CommunitySiteArticle } from '@/store/modules-community-admin/community-site'
import Loading from '@/components/loading/index.vue'
import { useToast } from 'vue-toastification'
import postServices from '@/services/post.services'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import userPostService from '@/services/user-post.services'
import EditorPreview from '@/views/community-admin/community-site/components/EditorPreview.vue'
import HashTag from '@/components/hash-tag/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
const router = useRouter()
const toast = useToast()

const loading = ref<boolean>(false)

const mode: ComputedRef<ArticleCreateMode> = computed(() => (route.params.idArticle ? ArticleCreateMode.EDIT : ArticleCreateMode.CREATE))
const articleData = computed<CommunitySiteArticle>(() => store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.GET_ARTICLE] ?? {})
const imageMapping = computed<CommunitySiteArticle>(() => store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.IMAGE_MAPPING] ?? {})
const articlePublishStatusText = computed(() => {
  if (!isEmpty(articleData.value)) {
    return articleData.value[ARTICLE_PUBLISH_STATUS_FIELD_NAME] === ARTICLE_PUBLISHED_PUBLIC_VALUE ? translate('public') : translate('private')
  }
  return ''
})
const autoPostText = computed(() => {
  if (!isEmpty(articleData.value)) {
    return articleData.value[ARTICLE_AUTO_POST_FIELD_NAME] === AUTO_POST_ENABLE ? translate('CK20AutoPostYes') : translate('CK20AutoPostNo')
  }
  return ''
})
const displayedTag = computed(() => {
  return articleData.value[ARTICLE_TAGS_FIELD_NAME]?.filter((tag) => !tag['_destroy'])
})

const handleBack = () => {
  router.go(-1)
}

const requestFormData = () => {
  let content = articleData.value[ARTICLE_CONTENT_FIELD_NAME]
  Object.keys(imageMapping.value).forEach((key) => {
    content = content?.replaceAll(key.replaceAll(/&/g, '&amp;'), imageMapping.value[key])
  })
  let tags = articleData.value[ARTICLE_TAGS_FIELD_NAME]
  if (mode.value === ArticleCreateMode.EDIT) {
    tags = tags.map((t) => {
      if (t.id?.includes('new')) {
        return pick(t, 'name')
      }
      return t
    })
  } else {
    tags = tags.map((t) => pick(t, 'name'))
  }
  return {
    ...pick(articleData.value, ARTICLE_TITLE_FIELD_NAME, ARTICLE_AUTO_POST_FIELD_NAME, ARTICLE_PUBLISH_STATUS_FIELD_NAME),
    [ARTICLE_CONTENT_FIELD_NAME]: content,
    [ARTICLE_TAGS_FIELD_NAME]: tags,
    uploaded_images: Object.values(imageMapping.value).map((url) => url.split('?')[0]),
    ...(mode.value === ArticleCreateMode.CREATE && {
      content_type: 5,
      create_by_admin: true,
    }),
  }
}

const handleSubmit = async () => {
  if (mode.value === ArticleCreateMode.CREATE) {
    await handleSubmitCreatePost()
  } else {
    await handleSubmitUpdatePost()
  }
}

const handleSubmitCreatePost = async () => {
  loading.value = true
  try {
    const formData = requestFormData()
    const response = await postServices.createPost(formData, route.params.id)
    if (response.status === 200) {
      clearFormData()
      showCreateArticleCompleteModal()
    }
  } catch (err) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: 'CK30CreateArticleFailedToastMsg',
      },
    })
  } finally {
    loading.value = false
  }
}

const handleSubmitUpdatePost = async () => {
  loading.value = true
  try {
    const formData = requestFormData()
    const response = await userPostService.updateUserPosts(route.params.idArticle, formData)
    if (response.status === 200) {
      clearFormData()
      showCreateArticleCompleteModal()
    }
  } catch (err) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: 'CK30CreateArticleFailedToastMsg',
      },
    })
  } finally {
    loading.value = false
  }
}

const handleModalCloseClick = () => {
  const storedQueries = toRaw(store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.GET_CURRENT_QUERY]) ?? {}
  router.replace({
    path: URL_ARTICLE_LIST_PATH(router.currentRoute.value.params.id?.toString() ?? '0'),
    query: storedQueries,
  })
}

const showCreateArticleCompleteModal = () => {
  const modal = new Modal(document.getElementById(CREATE_COMPLETE_MODAL_ID))
  modal.show()
}

const clearFormData = () => {
  store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.CLEAR_FORM_ARTICLE_DATA)
  store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.UPDATE_RESET_FLAG, { flag: true })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: _unref(breadcrumb)(_unref(route).params?.id.toString(), _unref(mode), true),
      class: "mx-0"
    }, null, 8, ["breadcrumb"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(articleData)[_unref(ARTICLE_TITLE_FIELD_NAME)]), 1),
        _createVNode(EditorPreview, {
          content: _unref(articleData)[_unref(ARTICLE_CONTENT_FIELD_NAME)]
        }, null, 8, ["content"]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedTag), (tag) => {
            return (_openBlock(), _createBlock(HashTag, {
              key: tag.id,
              tag: tag,
              class: "me-2 mb-2"
            }, null, 8, ["tag"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(translate)('publicSettings')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(articlePublishStatusText)), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(translate)('CK20AutoPost')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(autoPostText)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(Button, {
          title: _unref(mode) === _unref(ArticleCreateMode).CREATE ? _unref(translate)('cancel') : _unref(translate)('postEdit'),
          type: 'secondary',
          onClick: handleBack,
          className: "fw-bold me-2"
        }, null, 8, ["title"]),
        _createVNode(Button, {
          title: _unref(mode) === _unref(ArticleCreateMode).CREATE ? _unref(translate)('signUp') : _unref(translate)('update'),
          disabled: loading.value,
          loading: loading.value,
          onClick: handleSubmit,
          className: "fw-bold",
          type: "secondary"
        }, null, 8, ["title", "disabled", "loading"])
      ])
    ]),
    _createVNode(CompleteModal, {
      id: _unref(CREATE_COMPLETE_MODAL_ID),
      header: _unref(mode) === _unref(ArticleCreateMode).CREATE ? _unref(translate)('CK30CreateArticleSuccessTitle') : _unref(translate)('CM10ArticleUpdate'),
      "content-message": _unref(mode) === _unref(ArticleCreateMode).CREATE ? _unref(translate)('CK30CreateArticleSuccessDescription') : _unref(translate)('CM20CreateArticleSuccessDescription'),
      "button-click": handleModalCloseClick
    }, null, 8, ["id", "header", "content-message"]),
    _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})